import template from './foodBenefitWorkTeam.html';
import controller from './foodBenefitWorkTeam.controller';
import './foodBenefitWorkTeam.scss';

let foodBenefitWorkTeamComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default foodBenefitWorkTeamComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/features/foodBenefitWorkTeam/foodBenefitWorkTeam.component.js